<template>
  <div v-bind="$attrs">
    <svg-icon  type-icon="mdi" :size="size" :path="icon[icono as MdiKeys]"></svg-icon>
  </div>
</template>
<script setup lang="ts">
import type { MdiKeys } from '@/modules/Core/interfaces'
import * as icon from '@mdi/js'
defineProps<{ icono: string , size?: number}>()
</script>
